import React, { useMemo } from "react";

const ExternalLink = ({ className, href, children, onClick = () => {} }) => {
  const normalizedHref = useMemo(() => {
    const urlStartKeys = ["http://", "https://", "mailto:", "tel:"];
    return urlStartKeys?.some((item) => href?.startsWith(item))
      ? href
      : "http://" + href;
  }, [href]);
  return (
    <a
      onClick={onClick}
      className={`text-blue-link truncate ${className} `}
      href={normalizedHref}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

export default ExternalLink;
